// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json.json`.

export const environment = {
  production: false,
  stsAuthority: window["env"].stsAuthority || " ",
  clientId: window["env"].clientId || " ",
  clientRoot: window.location.hostname,
  clientScope: window["env"].clientScope || " ",
  apiRoot: window["env"].apiRoot || " ",
  apiUrl: window["env"].apiUrl || " ",
  authApiUrl: window["env"].authApiUrl || " ",
  blobConnection: window["env"].blobConnection || " ",
  blobContainer: window["env"].blobContainer || " ",
  ctserviceEndpoint:  window["env"].ctserviceEndpoint || " ",
  ctserviceUrl: window["env"].ctserviceUrl || " "
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
